import { Auth } from '@ax/auth';
import style from './DuplicateTab.module.scss';
import { useNavigate } from 'react-router-dom';
import { clearVisitDetails, setSelectedDate, useAppDispatch, userSignedOut } from '@ax/redux-store';
import { routerPaths } from '@ax/constants';
import { useLogout } from '@/hooks/api';
import { usePasscodeSession } from '@/hooks/usePasscodeSession.tsx';

const DuplicateTab = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { mutateAsync: logoutUser } = useLogout();
  const { clearSession } = usePasscodeSession();

  const logout = async () => {
    await logoutUser({ logoutType: 'General' });
    Auth.logout();

    if (!Auth.isLoggedIn()) {
      navigate(routerPaths.root);
      dispatch(setSelectedDate({ date: '' }));
      dispatch(clearVisitDetails());
      dispatch(userSignedOut());
      clearSession();
    }
  };

  return (
    <main className={style.container}>
      <div className={style.content}>
        <h4 className={style.content__header}>Warning! (Duplicate tab)</h4>
        <p className={style.content__text}>
          You've already application running on another tab! Please close this tab. This issue may
          also happen if you didn't log out properly last time.
        </p>
      </div>
      <p className={style.footer}>
        <small>
          If you accidently closed other tab then please{' '}
          <span
            className={style.footer__button}
            onClick={logout}
          >
            click here to sign out
          </span>{' '}
          and sign in again!
        </small>
      </p>
    </main>
  );
};

export default DuplicateTab;
